var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.bem(), _vm.isLowAndroid ? 'low-android' : '']},[_c('nx-empty',{attrs:{"type":_vm.type,"image":_vm.image,"isFullScreen":false,"description":_vm.description,"buttonText":_vm.buttonText}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }